import Alpine from "alpinejs";
import dropdown from "./dropdown";

Alpine.data("filterData", () => {
    const defaults = {
        axios: window.axios,
        quantity: null,
        _attr: {},

        // Initial attributes data with initial options and values
        attributes: {},
        remote: false,
        remoteContainer: "",

        // Attribute constructor
        attribute(name) {
            if(!this._attr.hasOwnProperty(name)) {
                // Check if attribute has data
                if(!this.attributes.hasOwnProperty(name))
                    throw `Unknown attribute name ${name}`;

                // Creating an attribute instance
                this._attr[name] = dropdown(name, this.attributes[name]);
            }

            return this._attr[name];
        },

        // On filter submit
        onFilterSubmit(event) {
            event.preventDefault();
            event.stopImmediatePropagation();

            if(this.remote) {
                this.reloadRemote();
            } else {
                // Redirect to filters page
                let url = `/filters?${this.serializeQuery()}`;
                window.location.href = url;
            }
        },

        // On change attribute
        onAttributeChange(name) {
            // If brand, reload models
            if(name === "brand_id")
                this.reloadModels();

            // If models, reload equipment
            if(name === "model_id")
                this.reloadEquipment();

            // Reload results
            if(this.remote) {
                this.reloadRemote();
            } else {
                this.reloadQuantity();
            }

        },

        reloadQuantity() {
            let url = `/filters/quantity?${this.serializeQuery()}`;
            this.axios.get(url).then(r => {
                this.quantity = r.data.quantity;
            });
        },

        //<editor-fold desc="Reload dropdown options">
        reloadModels() {
            let brandAttr = this._attr["brand_id"],
                modelAttr = this._attr["model_id"];
            if(!brandAttr || !modelAttr)
                return;

            // Reset model attr
            modelAttr.value = null;
            modelAttr.options = [];

            let url = `/filters/models?brand_id=${brandAttr.value }`;
            this.axios.get(url).then(r => {
                modelAttr.options = r.data.options;
            });
        },

        reloadEquipment() {
            let modelAttr = this._attr["model_id"],
                equipAttr = this._attr["equipment_group_id"];
            if(!modelAttr || !equipAttr)
                return;

            // Reset equipment attr
            equipAttr.value = null;
            equipAttr.options = [];

            let url = `/filters/equipment?model_id=${modelAttr.value }`;
            this.axios.get(url).then(r => {
                equipAttr.options = r.data.options;
            });
        },
        //</editor-fold>

        //<editor-fold desc="Remote reload">
        reloadRemote() {
            if(!this.remoteContainer)
                return;

            let remoteElement = document.querySelector(this.remoteContainer);
            remoteElement.innerHTML = "";
            remoteElement.classList.add("loading");

            let url = `/filters?${this.serializeQuery()}`;
            this.axios.get(url).then(r => {
                history.pushState(this.serializeState(), "", url);

                remoteElement.innerHTML = r.data;
                remoteElement.classList.remove("loading");
            });
        },
        //</editor-fold>

        //<editor-fold desc="Helpers">
        // Serializes query string from form attributes.
        serializeQuery() {
            let queryString = [];
            for(let name in this._attr) {
                if(!this._attr.hasOwnProperty(name))
                    continue;
                let attr = this._attr[name];
                if(attr.value === null)
                    continue;
                queryString.push(`${name}=${attr.value}`);
            }
            return queryString.join("&");
        },

        serializeState() {
            let state = {};
            for(let name in this._attr) {
                if(!this._attr.hasOwnProperty(name))
                    continue;
                let attr = this._attr[name];
                if(attr.value === null)
                    continue;
                state[name] = attr.value;
            }
            return state;
        }
        //</editor-fold>
    };
    return Object.assign(defaults, window.filterData);
});
